var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.$t('menu.BalancePurchase')))]),_c('PaymentList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }